import React from 'react'

function Retour() {
  return (
    <div>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 8.00019C11 7.63219 10.7013 7.33352 10.3333 7.33352L4.61979 7.33352L7.19531 4.758C7.45598 4.49733 7.45598 4.07529 7.19531 3.81529L7.13802 3.758C6.87735 3.49733 6.45531 3.49733 6.19531 3.758L2.42448 7.52883C2.16381 7.7895 2.16381 8.21154 2.42448 8.47154L6.19531 12.2424C6.45598 12.503 6.87802 12.503 7.13802 12.2424L7.19531 12.1851C7.45598 11.9244 7.45598 11.5024 7.19531 11.2424L4.61979 8.66685L10.3333 8.66685C10.7013 8.66685 11 8.36819 11 8.00019Z" fill="black"/>
        </svg>
    </div>
  )
}

export default Retour